// Cart
var cartDrawer = document.getElementById('cart-drawer');
function openCart(){ cartDrawer.classList.add('open'); document.body.style.overflow='hidden'; }
function closeCart(){ cartDrawer.classList.remove('open'); document.body.style.overflow=''; }
document.querySelector('.cart-toggle-btn').addEventListener('click', openCart);
document.querySelector('.cart-close').addEventListener('click', closeCart);
document.querySelector('.cart-overlay').addEventListener('click', closeCart);

function formatMoney(cents){ return '$'+(cents/100).toFixed(2)+' USD'; }

async function fetchCart(){
  try{
    var res = await fetch('/cart.js');
    var cart = await res.json();
    var countEl = document.getElementById('cart-count');
    var totalEl = document.getElementById('cart-total');
    var itemsEl = document.getElementById('cart-items');
    if(countEl) countEl.textContent = cart.item_count;
    if(totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if(!itemsEl) return;
    if(!cart.items || cart.items.length===0){
      itemsEl.innerHTML='<p class="cart-empty-msg">Your cart is empty.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function(item){
      return '<div style="display:flex;gap:14px;padding:14px 0;border-bottom:1px solid #dde1e7;">'
        +'<img src="'+item.image+'" alt="'+item.title+'" style="width:68px;height:68px;object-fit:cover;border-radius:8px;flex-shrink:0;">'
        +'<div style="flex:1;min-width:0;">'
        +'<p style="font-size:13px;font-weight:600;margin-bottom:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">'+item.title+'</p>'
        +(item.variant_title&&item.variant_title!=='Default Title'?'<p style="font-size:12px;color:#666;margin-bottom:4px;">'+item.variant_title+'</p>':'')
        +'<p style="font-size:13px;color:#4d9cd4;font-weight:700;">'+formatMoney(item.final_price)+' &times; '+item.quantity+'</p>'
        +'</div>'
        +'<button onclick="removeCartItem(\''+item.key+'\')" style="color:#999;font-size:18px;background:none;border:none;cursor:pointer;align-self:flex-start;padding:2px 6px;">&#x2715;</button>'
        +'</div>';
    }).join('');
  } catch(e){ console.error('Cart error',e); }
}

async function addToCart(variantId, quantity){
  quantity = quantity || 1;
  try{
    var res = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:variantId,quantity:quantity})
    });
    if(res.ok){ await fetchCart(); openCart(); }
  } catch(e){ console.error('Add to cart error',e); }
}

async function removeCartItem(key){
  await fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:0})
  });
  fetchCart();
}

document.addEventListener('click', function(e){
  var btn = e.target.closest('.add-to-cart-btn');
  if(!btn) return;
  var id = parseInt(btn.dataset.variantId);
  if(id) addToCart(id, 1);
});

fetchCart();

// Mobile nav
var mobileNav = document.getElementById('mobile-nav');
document.querySelector('.hamburger-btn').addEventListener('click', function(){ mobileNav.classList.add('open'); document.body.style.overflow='hidden'; });
document.querySelector('.mobile-nav-close').addEventListener('click', function(){ mobileNav.classList.remove('open'); document.body.style.overflow=''; });
document.querySelector('.mobile-nav-overlay').addEventListener('click', function(){ mobileNav.classList.remove('open'); document.body.style.overflow=''; });

// Tracking
var trackBtn = document.getElementById('track-btn');
if(trackBtn){
  trackBtn.addEventListener('click', function(){
    var num = (document.getElementById('tracking-input').value||'').trim();
    var result = document.getElementById('track-result');
    if(!num){ result.textContent='Please enter a tracking number.'; return; }
    result.innerHTML='<span style="color:#4d9cd4;">Looking up <strong>'+num+'</strong>...</span>';
    setTimeout(function(){
      window.open('https://t.17track.net/en#nums='+encodeURIComponent(num),'_blank');
      result.textContent='Opened in new tab.';
    }, 500);
  });
}

// ESC key
document.addEventListener('keydown', function(e){
  if(e.key==='Escape'){ closeCart(); mobileNav.classList.remove('open'); document.body.style.overflow=''; }
});
